import { useState } from 'react';

/**
 * Form value with state wrapper
 * @param {Object=} props
 * @param {*=} props.initialState
 * @returns {[*, function]}
 */

function useForm({ initialState = '' }) {
  const [value, setValue] = useState(initialState);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return [value, handleChange];
}

export default useForm;
